import React, { useState } from "react";
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";

/* 🔥 Firebase Config */
const firebaseConfig = {
apiKey: "AIzaSyAXN63gysGZmtL_4U9UAKA6C9g7yZCqGQk",
  authDomain: "tsk-realtors.firebaseapp.com",
  projectId: "tsk-realtors",
  storageBucket: "tsk-realtors.firebasestorage.app",
  messagingSenderId: "677545217094",
  appId: "1:677545217094:web:2ff0ec8ebe81433588ce47",
  measurementId: "G-1TB3CPE4H7"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

function BrochureForm() {
  const [form, setForm] = useState({
    name: "",
    mobile: "",
    city: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.mobile.length !== 10) {
      alert("Enter valid mobile number");
      return;
    }

    try {
      await addDoc(collection(db, "users"), {
        ...form,
        createdAt: new Date(),
      });

      alert("Form Submitted Successfully!");

      /* 📥 Download Brochure */
      const link = document.createElement("a");
      link.href = "/brochure.pdf"; // put in public folder
      link.download = "brochure.pdf";
      link.click();

      setForm({ name: "", mobile: "", city: "" });

    } catch (error) {
      console.error(error);
      alert("Error saving data");
    }
  };

  return (
          
    <div style={styles.container}>
      
      <form style={styles.formBox} onSubmit={handleSubmit}>
        
        <h2 style={styles.title}>Unicorn Aerocity Download Brochure</h2>
  <div className="album py-1">
        <div className="container">
        <input
          type="text"
          name="name"
          placeholder="Enter Name"
          value={form.name}
          onChange={handleChange}
          required
          style={styles.input}
        />

        <input
          type="text"
          name="mobile"
          placeholder="Mobile Number"
          value={form.mobile}
          onChange={handleChange}
          required
          style={styles.input}
        />

        <input
          type="text"
          name="city"
          placeholder="City"
          value={form.city}
          onChange={handleChange}
          required
          style={styles.input}
        />
 </div>
     </div>
        <button type="submit" style={styles.button}>
          Submit & Download
        </button>
        
      </form>
    
    </div>
  );
}

/* 🎨 Inline CSS */
const styles = {
  container: {
    minHeight: "70vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "18px", // ✅ fixes left-right gap
    background: "linear-gradient(135deg, #224156, #ABBFCD)",
    fontFamily: "Arial, sans-serif",
  },

  formBox: {
    background: "#ffffff",
    padding: "25px",
    borderRadius: "12px",
    width: "100%",
    maxWidth: "520px", // ✅ responsive width
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    textAlign: "center",
  },

  title: {
    marginBottom: "20px",
    color: "#333",
    fontSize: "22px",
    fontWeight: "600",
  },

  input: {
    width: "100%",
    padding: "12px",
    margin: "10px 0",
    border: "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "14px",
    outline: "none",
    transition: "0.3s",
  },

  button: {
    width: "100%",
    padding: "12px",
    marginTop: "10px",
    background: "#667eea",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "0.3s",
  },
};

export default BrochureForm;